import { Trans } from '@lingui/react'

import { OFFER_TYPE_MIRAKL, OFFER_TYPE_SAE } from 'shared/consts/marketplace'
import { isMarketplace } from 'shared/experiments/utils/featureFlags'
import Price from 'views/components/atoms/Price'
import OfferItem from 'views/components/organisms/OfferItem'
import OfferProduct from 'views/components/organisms/OfferProduct'
import SellerModal from 'views/components/organisms/SellerModal'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'

export default withShopAndRuntimeConfig(props => {
  const {
    publicRuntimeConfig: {
      publicConfig: { tenant },
      pageProperties: {
        experiments,
        bestPrice,
        offerCount,
        offersResponse,
        product,
      },
    },
  } = props
  let bestOffer = {}
  const offers = offersResponse.offers
    .filter(offer =>
      [OFFER_TYPE_SAE, OFFER_TYPE_MIRAKL].includes(offer.offerType)
    )
    .map(offer => {
      const {
        nowProductGroup,
        offerId,
        offerPrice,
        offerType,
        seller,
        offerFlags,
        offerPromotion,
        redPointsMultiplierIsValid,
        multiplierRP,
      } = offer
      const { basePrice, shippingPrice, price, currency, totalPrice } =
        offerPrice
      if (!bestOffer.offerId) {
        bestOffer = offer
      } else {
        bestOffer =
          bestOffer.offerPrice.totalPrice < totalPrice ? bestOffer : offer
      }

      return {
        basePrice,
        bestPrice: offerFlags.includes('bestPrice'),
        nowProductGroup,
        offerId,
        offerType,
        offerPromotion,
        prices: [{ amount: price, currency, type: 'retail' }],
        seller,
        shippingPrice: { amount: shippingPrice },
        productId: product.upid,
        redPointsMultiplierIsValid,
        multiplierRP,
      }
    })

  return (
    <div className="l-grid__item u-no-padding p-Offers__content">
      <OfferProduct {...product} />
      <div className="p-Offers__subcontent">
        <h2
          className="l-grid__item u-padding-large--ends u-no-margin u-padding--left p-Offers__h2"
          data-qa-id="offers-number"
        >
          <Trans
            id="offerProduct.label.offers"
            values={{
              offers: offerCount,
              price: (
                <span data-qa-id="cheapest-price">
                  <Price {...bestPrice} />
                </span>
              ),
            }}
          />
        </h2>
        {offers.map(offer => (
          <OfferItem
            key={offer.offerId}
            isBestOffer={offer.offerId === bestOffer.offerId}
            {...offer}
            marketplaceEnabled={isMarketplace(experiments, tenant)}
          />
        ))}
        <SellerModal />
      </div>
    </div>
  )
})
